import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M6.41 6 5 7.41 9.58 12 5 16.59 6.41 18l6-6z"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "m13 6-1.41 1.41L16.17 12l-4.58 4.59L13 18l6-6z"
}, "1")], 'KeyboardDoubleArrowRightTwoTone');